import React, { Component } from 'react';
import moment from 'moment-timezone';

class StatusBar extends Component {
  state = {
    time: new Date(),
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ time: new Date() });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <svg viewBox="0 0 302 20">
        <path
          d="M294.272727,9 L297,9 L292.090909,15 L293.727273,10.5 L293.090909,10.5 L293.090909,9 L294.173554,9 L295.363636,5 L291,10.5 L293.727273,10.5 L295.090909,10.5 L295.090909,9 L294.272727,9 Z"
          id="lightning"
          fill="#FFFFFF"
          fillRule="evenodd"
        />
        <g
          id="battery"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(262.000000, 4.000000)"
        >
          <rect
            id="inside"
            fill="#4CD964"
            x="2"
            y="2.5"
            width="20"
            height="7.5"
            rx="1"
          />
          <path
            d="M25,4.56300874 C25.8626136,4.78503014 26.5,5.56808029 26.5,6.5 C26.5,7.43191971 25.8626136,8.21496986 25,8.43699126 L25,4.56300874 Z"
            id="side"
            fill="#FFFFFF"
          />
          <path
            d="M2,0.5 L22,0.5 C23.1045695,0.5 24,1.3954305 24,2.5 L24,10 C24,11.1045695 23.1045695,12 22,12 L2,12 C0.8954305,12 1.3527075e-16,11.1045695 0,10 L0,2.5 C-1.3527075e-16,1.3954305 0.8954305,0.5 2,0.5 Z M2,1.5 C1.44771525,1.5 1,1.94771525 1,2.5 L1,10 C1,10.5522847 1.44771525,11 2,11 L22,11 C22.5522847,11 23,10.5522847 23,10 L23,2.5 C23,1.94771525 22.5522847,1.5 22,1.5 L2,1.5 Z"
            id="frame"
            fill="#FFFFFF"
          />
        </g>
        <text
          id="12:00"
          fontFamily=".AppleSystemUIFont"
          fontSize="11"
          fontWeight="normal"
          fill="#FFFFFF"
        >
          <tspan x="136.848948" y="15">
            {moment(this.state.time).format('HH:MM')}
          </tspan>
        </text>
        <text
          id="Carrier"
          fontFamily=".AppleSystemUIFont"
          fontSize="12"
          fontWeight="normal"
          fill="#FFFFFF"
        >
          <tspan x="26" y="15">
            InsideLabs
          </tspan>
        </text>
        <g
          id="signal"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(6.000000, 5.000000)"
          fill="#FFFFFF"
        >
          <rect id="4" x="13.5" y="0" width="3" height="10" rx="1" />
          <rect id="3" x="9" y="2" width="3" height="8" rx="1" />
          <rect id="2" x="4.5" y="4" width="3" height="6" rx="1" />
          <rect id="1" x="0" y="5" width="3" height="5" rx="1" />
        </g>
      </svg>
    );
  }
}

export default StatusBar;



// WEBPACK FOOTER //
// ./src/views/app/components/StatusBar.js